import React from "react"
import { usePortalTenant } from "context/PortalTenantContext"
import LandingPage from "pages/Onboarding/LandingPage"
import Login from "pages/Authentication/Login"

const PublicHomeRoute = () => {
  const { isCustomLoginActive } = usePortalTenant()

  if (isCustomLoginActive) {
    return <Login />
  }

  return <LandingPage />
}

export default PublicHomeRoute
